import { fetch as fetchPolyfill } from 'whatwg-fetch';

const newsletterURL = window.AppConfig.newsletter_config;

const SELECTOR = '.js-newsletter';
const DEFAULT_INTERESTS = [17,18];
let buttonText;

export function init() {
    function renderNewsletter() {
        const el = document.querySelectorAll(SELECTOR);

        if (el === null) {
            return false;
        }

        getData().then(response => {
            if (response) {
                el.forEach(element => {
                    let config = response;
                    config.interests = element.dataset.interests ? element.dataset.interests.split(',') : DEFAULT_INTERESTS;
                    buttonText = element.dataset.buttonText ? element.dataset.buttonText : 'Subscribe';

                    element.dataset.configNw = JSON.stringify(config);
                    if ('blocksOfficeRenderNewsletterWidget' in window) {
                        window.blocksOfficeRenderNewsletterWidget(element);
                    }
                    const el = element.querySelector('.global-newsletter__subscribe');
                    if (el) {
                        el.innerHTML = buttonText;
                    }
                    const emailInput = element.querySelector('.global-newsletter__email');
                    if (emailInput) {
                        emailInput.setAttribute('placeholder', 'Your email address');
                        const label = element.querySelector('.global-newsletter__label');
                        if (label) {
                            const wrapper = document.createElement('div');
                            wrapper.className = 'global-newsletter__input-wrapper';
                            emailInput.parentNode.insertBefore(wrapper, emailInput);
                            wrapper.appendChild(emailInput);
                            wrapper.appendChild(label);
                        }
                    }
                });
            }
        })

    }

    function getData() {
        const fetchConfig = {headers: {}};
        fetchConfig.credentials = 'include';
        return fetchPolyfill(newsletterURL, fetchConfig)
            .then(response => response.json());
    }
    if (newsletterURL) {
        renderNewsletter();
    }
}

export default { init }
